module.exports = "/packs/010-66bb975dab7a611cffe2086017f665b6.jpg";